import styled from "styled-components";
import {Tooltip} from "antd";
import {TextColor} from "../../components/Text";

export const WalletDetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`
export const WalletDetailHeaderLeft = styled.div`
  display: flex;
  align-items: center;
`
export const WalletDetailHeaderRight = styled.div`
  @media screen and (max-width: 1024px) {
    & {
      margin-top: 32px !important;
    }
  }
`
export const BalanceTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 31px;
  @media screen and (max-width: 1024px) {
    & {
      margin-bottom: 16px;
    }
  }
`;
export const BalanceValue = styled.div`
  display: flex;
  align-items: center;
`;
export const BalanceValueBTC = styled(TextColor)`
  font-weight: 600;
  font-size: 35px;
  line-height: 35px;
  color: #485EA8;
  @media screen and (max-width: 1024px) {
    & {
      font-weight: 600;
      font-size: 26px;
      line-height: 24px;
    }
  }
`;
export const BalanceValueEqual = styled(TextColor)`
  font-weight: 600;
  font-size: 35px;
  line-height: 35px;
  color: #707070;
  @media screen and (max-width: 1024px) {
    & {
      font-weight: 600;
      font-size: 26px;
      line-height: 24px;
    }
  }
`;
export const BalanceValueIcon = styled.div`
  margin: 0 24px;
  @media screen and (max-width: 1024px) {
    & {
      margin: 0 16px 0 0;
    }

    & svg {
      width: 16px;
    }
  }
`;
export const BalanceContainer = styled.div`
  margin-bottom: 80px;
  position: relative;

  @media screen and (max-width: 1024px) {
    & {
      margin-bottom: 55px;
    }
  }
`;
export const BalanceText = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  @media screen and (max-width: 1024px) {
    & {
      font-weight: 600;
      font-size: 16px;
      line-height: 25px;
      margin-left: 65px;
    }
  }
`;
export const WalletDetailHeaderLeftIcon = styled.div`
  margin-right: 14px;

  & > * {
    width: 50px;
    height: 50px;
  }
`
export const WalletDetailHeaderLeftContent = styled.div`
`

export const WalletDetailRow = styled.div`
  border-top: 1px solid #FFFFFF;
  display: flex;
  align-items: flex-start;
  padding-top: 45px;
  margin-top: 36px;

  &.game-version {
    flex-direction: row-reverse;
  }

  & > div:first-child {
    margin-right: 70px;
    width: 530px;
  }

  &.game-version > div:last-child {
    margin-right: 100px;
    width: auto;
    flex: 1;
  }

  & > div:last-child {
    flex: 1;
  }

  &.game-version > div:first-child {
    flex: inherit;
    width: 530px;
  }

  @media screen and (max-width: 1024px) {
    flex-direction: column !important;

    & > div:first-child {
      margin-right: 0px;
      width: 100%;
    }

    & > div:last-child {
      width: 100%;
      margin-top: 36px;
      margin-bottom: 100px;
      margin-right: 0 !important;
    }
  }
`;

export const WalletDetailNotify = styled.div`
  background: #F5AA194D;
  border-radius: 25px;
  padding: 35px 25px;
  display: flex;
  align-items: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #000000;
  margin-bottom: 6px;


  & svg {
    margin-top: 3px;
    margin-right: 12px;
    width: 20px;
    height: 20px;
    flex: none;
  }

  & > div {
    flex: 1;
  }

  & h1 {
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: #000000;
    margin-bottom: 6px;
  }

  & ul {
    margin-bottom: 0;
    list-style: disc;
    padding-left: 18px;

    li {
      margin-top: 16px;
    }
  }
  &.withdrawal-sot{
    border-radius: 10px;
    padding: 16px 16px 16px 24px;
    flex-wrap: wrap;
    gap: 8px;
    flex-direction: column;
  }

  @media screen and (max-width: 1024px) {
    & {
      //font-size: 14px;
      padding: 35px 17px;
      //margin-top: 50px;
      width: 100% !important;
    }
  }
`

export const WalletRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;
export const WalletRowLeft = styled.div`
  flex: 1;
`;
export const WalletRowRight = styled.div`
  width: 260px;
  @media screen and (max-width: 1024px) {
    & {
      width: 100%;
      margin-top: 48px;
    }
  }
`;

export const WalletRowRightFaq = styled.div`
  & h1 {
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: #707070;
    margin-bottom: 20px;

    @media screen and (max-width: 1024px) {
      & {
      }
    }
  }
`;
export const WalletRowRightFaqItem = styled.a`
  font-weight: 400;
  font-size: 16px;
  line-height: 35px;
  text-decoration-line: underline;
  color: #707070;
  display: flex;
  align-items: center;

  & svg {
    margin-right: 6px;
  }

  @media screen and (max-width: 1024px) {
    & {
      font-size: 14px;
    }
  }
`;

export const WalletAlert = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #E5665B;
  margin-bottom: 55px;
  text-align: left;
`;

export const WalletAddress = styled.div``;
export const WalletAddressTitle = styled(TextColor)`
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #707070;
  margin-bottom: 7px;
  display: inline-flex;
`;
export const WalletAddressValue = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & b {
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: #707070;
  }

`;
export const WalletAddressCopy = styled.div`
  margin-left: 18px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;
export const WalletAddressQR = styled.div`
  & > * {
    margin-top: 29px;
  }

  @media screen and (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const WalletConvertInfo = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 40px;
`;
export const WalletConvertInfoItem = styled.div`
  display: flex;
  @media screen and (max-width: 1024px) {
    justify-content: space-between;
  }
`;
export const WalletConvertInfoItemTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  color: #000000;
  display: flex;
  align-items: center;
  min-width: 180px;
`;
export const WalletConvertInfoItemValue = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 40px;
  color: #000000;
  margin-left: 30px;
  white-space: pre;
  @media screen and (max-width: 1024px) {
    text-align: right;
  }
`;

export const TooltipView = styled(Tooltip)`

`

export const FaqIcon = () => (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.40625 4.6875C7.80321 4.6875 7.3125 4.19679 7.3125 3.59375V0H1.71875C0.771 0 0 0.771 0 1.71875V14.2812C0 15.229 0.771 16 1.71875 16H10.4688C11.4165 16 12.1875 15.229 12.1875 14.2812V4.6875H8.40625ZM2.5625 11.25H4.83496C5.09392 11.25 5.30371 11.4598 5.30371 11.7188C5.30371 11.9777 5.09392 12.1875 4.83496 12.1875H2.5625C2.30354 12.1875 2.09375 11.9777 2.09375 11.7188C2.09375 11.4598 2.30354 11.25 2.5625 11.25ZM2.09375 9.21875C2.09375 8.95979 2.30354 8.75 2.5625 8.75H9.4375C9.69646 8.75 9.90625 8.95979 9.90625 9.21875C9.90625 9.47771 9.69646 9.6875 9.4375 9.6875H2.5625C2.30354 9.6875 2.09375 9.47771 2.09375 9.21875ZM9.4375 6.25C9.69646 6.25 9.90625 6.45979 9.90625 6.71875C9.90625 6.97771 9.69646 7.1875 9.4375 7.1875H2.5625C2.30354 7.1875 2.09375 6.97771 2.09375 6.71875C2.09375 6.45979 2.30354 6.25 2.5625 6.25H9.4375Z"
            fill="#707070"/>
        <path
            d="M8.25 3.59375C8.25 3.67984 8.32017 3.75 8.40625 3.75H11.9785C11.8928 3.59163 11.7825 3.44629 11.6499 3.32079L8.63671 0.470211C8.51988 0.359544 8.3895 0.267253 8.25 0.194336V3.59375Z"
            fill="#707070"/>
    </svg>
)

export const InfoIcon = (props) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_381_25783)">
            <path
                d="M2.92766 2.92766C4.8781 0.97522 7.23621 0 10 0C12.7638 0 15.1199 0.97522 17.0723 2.92766C19.0248 4.8801 20 7.22822 20 9.97602C20 12.7238 19.0248 15.0739 17.0723 17.0264C15.1199 18.9788 12.7638 19.952 10 19.952C7.23621 19.952 4.8781 18.9768 2.92766 17.0264C0.977218 15.0759 0 12.7238 0 9.97602C0 7.22822 0.97522 4.8781 2.92766 2.92766ZM4.35651 15.6435C5.91727 17.2042 7.79776 17.9856 10 17.9856C12.2022 17.9856 14.0827 17.2042 15.6435 15.6435C17.2042 14.0827 17.9856 12.1942 17.9856 9.97602C17.9856 7.75779 17.2042 5.8713 15.6435 4.30855C14.0827 2.7458 12.2002 1.96643 10 1.96643C7.79976 1.96643 5.91727 2.7478 4.35651 4.30855C2.79576 5.8693 2.01439 7.75979 2.01439 9.97602C2.01439 12.1922 2.79377 14.0827 4.35651 15.6435ZM8.99281 6.97842V4.96403H11.0072V6.97842H8.99281ZM8.99281 14.988V8.99281H11.0072V14.988H8.99281Z"
                fill="url(#paint0_linear_381_25783)"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_381_25783" x1="0" y1="9.9767" x2="20.001" y2="9.9767"
                            gradientUnits="userSpaceOnUse">
                <stop stopColor="#000"/>
                <stop offset="1" stopColor="#000"/>
            </linearGradient>
            <clipPath id="clip0_381_25783">
                <rect width="20" height="19.952" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)
export const InfoTooltipIcon = (props) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.92766 2.92766C4.8781 0.97522 7.23621 0 10 0C12.7638 0 15.1199 0.97522 17.0723 2.92766C19.0248 4.8801 20 7.22822 20 9.97602C20 12.7238 19.0248 15.0739 17.0723 17.0264C15.1199 18.9788 12.7638 19.952 10 19.952C7.23621 19.952 4.8781 18.9768 2.92766 17.0264C0.977218 15.0759 0 12.7238 0 9.97602C0 7.22822 0.97522 4.8781 2.92766 2.92766ZM4.35651 15.6435C5.91727 17.2042 7.79776 17.9856 10 17.9856C12.2022 17.9856 14.0827 17.2042 15.6435 15.6435C17.2042 14.0827 17.9856 12.1942 17.9856 9.97602C17.9856 7.75779 17.2042 5.8713 15.6435 4.30855C14.0827 2.7458 12.2002 1.96643 10 1.96643C7.79976 1.96643 5.91727 2.7478 4.35651 4.30855C2.79576 5.8693 2.01439 7.75979 2.01439 9.97602C2.01439 12.1922 2.79377 14.0827 4.35651 15.6435ZM8.99281 6.97842V4.96403H11.0072V6.97842H8.99281ZM8.99281 14.988V8.99281H11.0072V14.988H8.99281Z"
            fill="#707070"/>
    </svg>

)